import React from "react";
import { BASE_URL } from "../../config";

import WithAuth from "../../container/WithAuth";
import { countryIsoCodeToName } from "../../formatters";
import EditResearchRequestForm from "./EditResearchRequestForm";

const generateConflictDescription = formRef => {
    const formData = formRef.props.form.getFieldsValue([
        "entity_name",
        "country_code",
    ]);
    formData["country_code"] = countryIsoCodeToName(formData["country_code"]);
    return (
        <span>
            {`You are trying to create an entity named ${formData["entity_name"]} located in ${formData["country_code"]} which has been created before.`}
            <br />
            {`Please use the existing ${formData["entity_name"]} to create new research requests.`}
            <br />
            {
                "This will help you keep all the research requests for one entity in one place."
            }
        </span>
    );
};

const CreateResearchRequest = props => (
    <EditResearchRequestForm
        {...props}
        actionUrl={`${BASE_URL}/api/tickets/`}
        conflictTitle="Warning!"
        getConflictDescription={generateConflictDescription}
        title="Create request"
        disable={false}
    />
);

export default WithAuth(CreateResearchRequest);
